export function gotoAnchor(hash) {
  const element = $(`#${hash}`);

  if (!element) {

    return;
  }

  $('html, body').animate({
    scrollTop: element.offset().top,
  }, 500);
}

export function getLineHeight(element) {
  let tempElement = document.createElement(element.nodeName);
  tempElement.setAttribute("style","margin:0px;padding:0px;font-family:"+element.style.fontFamily+";font-size:"+element.style.fontSize);
  tempElement.innerHTML = "test";
  tempElement = element.parentNode.appendChild(tempElement);
  let lineHeight = tempElement.clientHeight;
  tempElement.parentNode.removeChild(tempElement);
  return lineHeight;
}

export function guid() {
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}



// WEBPACK FOOTER //
// ./client/app/core/libs/ui-helper.js